import moment from 'moment';
export default {
    save: function (name, data) {
        localStorage.setItem(name, JSON.stringify(data));
    },
    del: function (name) {
        localStorage.removeItem(name);
    },
    get: function (name) {
        var s = localStorage.getItem(name);
        if (s) {
            return JSON.parse(s);
        }
        return;
    },
    saveS: function (name, data) {
        localStorage.setItem(name, data);
    },
    getS: function (name) {
        return localStorage.getItem(name);
    },
    ssave: function (name, data) {
        sessionStorage.setItem(name, JSON.stringify(data));
    },
    sdel: function (name) {
        sessionStorage.removeItem(name);
    },
    sget: function (name) {
        var s = sessionStorage.getItem(name);
        if (s) {
            return JSON.parse(s);
        }
        return;
    },
    ssaveS: function (name, data) {
        sessionStorage.setItem(name, data);
    },
    sgetS: function (name) {
        return sessionStorage.getItem(name);
    },
    copy: function (obj) {
        return JSON.parse(JSON.stringify(obj));
    },
    //格式化时间
    formatTime: function (t) {
        if (t > 0) {
            return moment(t * 1000).format('YYYY-MM-DD HH:mm:ss');
        }
        return "None";
    },
    //格式化时间
    formatDateHHmmss: function (t) {
        if (t > 0) {
            return moment(t * 1000).format('YYYY-MM-DD HH:mm:ss');
        } else {
            return "-";
        }
    },
    //格式化时间
    formatTimeLong: function (t) {
        if (t > 0) {
            return moment(t).format('YYYY-MM-DD HH:mm:ss');
        }
        return "None";
    },
    //格式化时间
    formatDate: function (t) {
        if (t > 0) {
            return moment(t * 1000).format('YYYY-MM-DD');
        } else {
            return "None";
        }
    },
    nowStr: function () {
        return moment().format("yyyy-MM-dd HH:mm:ss");
    },
    //显示当前时间到分钟
    nowM: function () {
        return moment().format('YYYY-MM-DD HH:mm');
    },
    decodeUnicode: function (str) {
        return unescape(str.replace(/\\u/gi, '%u'))
    },
    now: function () {
        return parseInt((new Date()).getTime() / 1000);
    },
    nowLong: function () {
        return (new Date()).getTime();
    },
    intToDate: function (t) {
        if (t > 0) {
            var d = moment(t * 1000).format('YYYY-MM-DD HH:mm:ss');
            return new Date(d);
        } else {
            return new Date();
        }
    },
    //获得指定日期的00:00:00-23:59:59
    getFullDay: function (t) {
        var n = this.formatDate(t);
        var start = parseInt((new Date(n + " 00:00:00")).getTime() / 1000);
        var end = parseInt((new Date(n + " 23:59:59")).getTime() / 1000);
        return [start, end];
    },
    //获得指定日期的00:00:00-23:59:59
    getFullDayLong: function (t) {
        var n = this.formatDate(t);
        var start = parseInt((new Date(n + " 00:00:00")).getTime());
        var end = parseInt((new Date(n + " 23:59:59")).getTime());
        return [start, end];
    },
    //任意日期下的时间戳,返回对应今天对应时分秒的时间戳
    getTodayHHmmssLong: function (t) {
        let data = new Date(t);
        let str = this.formatDate(this.now()) + " " + moment(t).format('HH:mm:ss');

        return (new Date(str)).getTime();
    },
    //生成 [n,m] 的随机整数
    randomNum: function (minNum, maxNum) {
        switch (arguments.length) {
            case 1:
                return parseInt(Math.random() * minNum + 1, 10);
                break;
            case 2:
                return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
                break;
            default:
                return 0;
                break;
        }
    },
    getByteLength: function (str) {
        var len = 0;
        for (var i = 0; i < str.length; i++) {
            if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {
                len += 2;
            } else {
                len++;
            }
        }
        return len;
    },
    //中英文混合时,截取固定长度的最优返回字符串
    cutStr: function (str, maxLen) {
        var rstr = "";
        var i = 0;
        while (true) {
            var tmp = rstr + str.substring(i, i + 1);
            if (this.getByteLength(tmp) < maxLen && i < str.length) {
                rstr = tmp;
            } else {
                break;
            }
            i++;
        }
        return rstr;
    },
    //延迟函数
    sleep: function (tims) {
        return new Promise((resolved) => {
            setTimeout(() => {
                resolved();
            }, tims * 1000);
        });
    },
    //延迟函数
    sleepCallBack: function (tims, callback) {
        return new Promise((resolved) => {
            let t = setTimeout(() => {
                resolved();
            }, tims * 1000);
            if (callback) {
                callback(t, resolved);
            }
        });
    },
    sleepT: function (tims) {
        return new Promise((resolved) => {
            setTimeout(() => {
                resolved();
            }, tims);
        });
    },
    isNumber: function (value) {
        return typeof value === "number" && !isNaN(value) && Number.isFinite(value);
    },
    base64ToArrayBuffer: function (dataURL) {
        let byteString = atob(dataURL.split(',')[1]);
        let arrayBuffer = new ArrayBuffer(byteString.length);
        let uint8Array = new Uint8Array(arrayBuffer);
        for (let
            i = 0; i < byteString.length; i++) {
            uint8Array[i] = byteString.charCodeAt(i);
        }
        return uint8Array;
    },
    getRequest: function (url) {
        var theRequest = new Object();
        if (url.indexOf("?") != -1) {
            var str = url.substring(url.indexOf("?") + 1);
            var strs = str.split("&");
            for (var i = 0; i < strs.length; i++) {
                theRequest[strs[i].split("=")[0]] = decodeURIComponent(strs[i].replace(/%/g, "%25").split("=")[1]);
            }
        }
        return theRequest;
    },
    normalizeDomain: function (domain) {
        // 如果没有点前缀，自动加点
        if (domain && !domain.startsWith('.')) {
            if (this.isSecondLevelDomain(domain)) {
                return '.' + domain;  // 二级域名，自动加点
            }
            return domain;  // 如果不是二级域名，不加点
        }

        // 如果已经有点前缀，直接返回原值
        return domain;
    },
    isSecondLevelDomain: function (domain) {
        // 常见的 ICANN 顶级域名
        var icannTlds = ['com', 'org', 'net', 'gov', 'edu', 'io', 'co', 'tv'];  // 可以根据需要扩展
        // 复合顶级域名（例如国家/地区域名）
        var countryTlds = ['co.uk', 'com.au', 'edu.cn', 'gov.cn', 'ac.uk'];  // 示例，可以根据需要扩展

        var domainParts = domain.split('.');

        // 如果只有两部分，且后缀为常见的顶级域名，判断为二级域名
        if (domainParts.length === 2) {
            return icannTlds.includes(domainParts[1]);  // 如果是常见的顶级域名
        }

        // 判断复合顶级域名（如 .co.uk, .com.au 等）
        if (domainParts.length === 3) {
            var tld = domainParts.slice(-2).join('.');  // 获取复合的顶级域名（如 co.uk）
            return countryTlds.includes(tld);
        }

        return false;
    },
    /**
     * 防抖函数：n 秒内只执行最后一次
     * @param {Function} func 要执行的函数
     * @param {number} wait 延迟执行毫秒数
     * @param {boolean} immediate 是否立即执行一次（true 表示首次立即执行）
     * @returns {Function}
     */
    debounce(func, wait = 300, immediate = false) {
        let timer;

        return function (...args) {
            const context = this;

            if (timer) clearTimeout(timer);

            if (immediate && !timer) {
                func.apply(context, args);
            }

            timer = setTimeout(() => {
                if (!immediate) {
                    func.apply(context, args);
                }
                timer = null;
            }, wait);
        };
    },
    /**
     * 节流函数：每隔 n 秒只执行一次
     * @param {Function} func 要执行的函数
     * @param {number} wait 限制执行周期（毫秒）
     * @param {boolean} leading 是否首次立即执行（默认 true）
     * @param {boolean} trailing 是否在最后补执行一次（默认 true）
     * @returns {Function}
     */
    throttle(func, wait = 300, leading = true, trailing = true) {
        let timer = null;
        let previous = 0;

        return function (...args) {
            const context = this;
            const now = Date.now();

            if (!leading && previous === 0) previous = now;

            const remaining = wait - (now - previous);

            if (remaining <= 0) {
                if (timer) {
                    clearTimeout(timer);
                    timer = null;
                }
                previous = now;
                func.apply(context, args);
            } else if (trailing && !timer) {
                timer = setTimeout(() => {
                    previous = leading === false ? 0 : Date.now();
                    timer = null;
                    func.apply(context, args);
                }, remaining);
            }
        };
    }


}